// Module
var code = `<div id="send-to-nam" class="rb-dialog" style="width:350px;height:50px"> <div class="content layout-padding content-padding"> <button class="close standalone" ng-click="VM.cancel()">close</button> <h4 style="color:#37474f">Feature only available to Premier users</h4> </div> </div> `;
// Exports
export default code;